import {toast} from "react-toastify";
import {makeLink, translate} from "../../common/languages-helper";
import {useTranslation} from "react-i18next";
import {trackInviteShared} from "../../../analytics/events";

export const copyInviteText = (invite:any, profileData:any) => {
    let text = translate("EMDRlink | session #%s1\n\n Hey, please join session by clicking the link: %s2\n\n Looking forward to talking to you!\n\n Therapist: #%s3").replace(/%s1/g,invite.inviteeName).replace(/%s2/g, getLinkAddress(invite)).replace(/%s3/g, profileData.name);
    navigator.clipboard.writeText(text);
    trackInviteShared("copy_invitation");
    toast.success(translate("Invitation to %s has been copied to clipboard.").replace(/%s/g,invite.inviteeName));
    return text;
}
// Copies ONLY the session link (not the full invitation text) so the therapist
// can paste it straight into a browser or messenger (owner feedback). The full
// invitation text stays available behind the "Invitation content" action.
export const copyInviteLink = (invite:any) => {
    const link = getLinkAddress(invite);
    navigator.clipboard.writeText(link);
    trackInviteShared("copy_link");
    toast.success(translate("Session link copied to clipboard."));
    return link;
}
export const getLinkAddress = (invite:any) => {
    return window.location.protocol + "//" + window.location.host + makeLink("/jsession-")+invite._id;
}
